module.exports = __webpack_public_path__ + "static/media/bg-business.0585d399.png";